module.exports = __webpack_public_path__ + "static/itsm_capabilities_6-3dc15fe4c80593644f547154f599101a.png";